(function () {
  'use strict';
  var script = typeof document !== 'undefined' ? document.currentScript : null;
  var cfg = script ? script.dataset : {};
  var variantId = String(cfg.variantId || '41450134667319');
  var marker = 'labour-glue-2026';
  var title = cfg.discountTitle || 'Labour Weekend – Free EMA Glue with $100+ orders';
  var minimum = 10000;

  function own(item) {
    return String(item.variant_id || item.id) === variantId && item.properties && item.properties._ema_gift === marker;
  }

  function promotionSavings(item) {
    return (item.line_level_discount_allocations || item.discount_allocations || []).reduce(function (sum, allocation) {
      var application = allocation.discount_application || {};
      return sum + (application.title === title ? Number(allocation.amount || 0) : 0);
    }, 0);
  }

  function amount(cart) {
    return cart.items.reduce(function (sum, item) {
      return sum + (own(item) ? 0 : Number(item.final_line_price || 0) + promotionSavings(item));
    }, 0);
  }

  function fingerprint(cart) {
    return JSON.stringify([cart.currency, cart.items.filter(function (item) { return !own(item); }).map(function (item) {
      return [item.key, item.quantity, item.final_line_price, promotionSavings(item)];
    })]);
  }

  function plan(cart, active) {
    var gifts = cart.items.filter(own);
    var eligible = active && cart.currency === 'NZD' && amount(cart) >= minimum;
    var updates = {};
    gifts.forEach(function (item, index) {
      var quantity = eligible && index === 0 ? 1 : 0;
      if (item.quantity !== quantity) updates[item.key] = quantity;
    });
    return { eligible: eligible, add: eligible && gifts.length === 0, updates: updates };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { plan: plan, amount: amount, own: own, fingerprint: fingerprint };
    return;
  }
  if (!script || window.__emaFreeGlueInstalled) return;
  window.__emaFreeGlueInstalled = true;
  var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  var fetchOriginal = window.fetch.bind(window);
  var end = Date.parse(cfg.endsAt);
  var start = Date.parse(cfg.startsAt);
  var offset = Number(cfg.serverNow) * 1000 - Date.now();
  if (!Number.isFinite(offset)) offset = 0;
  var timer;
  var running;
  var requested = false;
  var blocked = null;

  function now() { return Date.now() + offset; }
  function active() { return Number.isFinite(start) && Number.isFinite(end) && now() >= start && now() < end; }
  if (active()) window.__emaGlueOfferInstalled = true;

  function request(path, body) {
    var options = { credentials: 'same-origin', cache: 'no-store', headers: { 'Content-Type': 'application/json' } };
    if (body) { options.method = 'POST'; options.body = JSON.stringify(body); }
    return fetchOriginal(root + path, options).then(function (response) {
      if (!response.ok) throw new Error('Gift cart request failed: ' + response.status);
      return response.json();
    });
  }

  function refresh() {
    var items = document.querySelector('cart-items');
    if (items && typeof items.refresh === 'function') return Promise.resolve(items.refresh());
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    return Promise.resolve();
  }

  async function reconcile() {
    var changed = false;
    try {
      var cart = await request('cart.js');
      var next = plan(cart, active());
      if (Object.keys(next.updates).length) {
        await request('cart/update.js', { updates: next.updates });
        changed = true;
        cart = await request('cart.js');
        next = plan(cart, active());
      }
      if (cart.items.some(own) && cart.items.reduce(function (sum, item) { return sum + promotionSavings(item); }, 0) <= 0) {
        var unpaid = {};
        cart.items.filter(own).forEach(function (item) { unpaid[item.key] = 0; });
        blocked = fingerprint(cart);
        await request('cart/update.js', { updates: unpaid });
        changed = true;
        await refresh();
        return;
      }
      if (next.add && blocked !== fingerprint(cart)) {
        var before = fingerprint(cart);
        await request('cart/add.js', { items: [{ id: Number(variantId), quantity: 1, properties: { _ema_gift: marker } }] });
        changed = true;
        cart = await request('cart.js');
        var paidGift = cart.items.filter(own);
        var savings = cart.items.reduce(function (sum, item) { return sum + promotionSavings(item); }, 0);
        if (!active() || !paidGift.length || savings <= 0 || !plan(cart, active()).eligible) {
          var remove = {};
          paidGift.forEach(function (item) { remove[item.key] = 0; });
          if (Object.keys(remove).length) await request('cart/update.js', { updates: remove });
          blocked = before;
        } else blocked = null;
      }
    } catch (error) {
      requested = false;
      throw error;
    }
    if (changed) await refresh();
  }

  function ensure() {
    clearTimeout(timer);
    requested = true;
    if (running) return running;
    running = (async function () {
      var attempts = 0;
      while (requested && attempts < 6) {
        requested = false;
        attempts += 1;
        await reconcile();
      }
    })().finally(function () { running = null; if (requested) schedule(); });
    return running;
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(function () { ensure().catch(function () {}); }, 80); }
  function mutation(input, options) {
    try {
      var url = new URL(typeof input === 'string' ? input : input.url, location.href);
      var method = String(options && options.method || input.method || 'GET').toUpperCase();
      return url.origin === location.origin && method !== 'GET' && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname);
    } catch (error) { return false; }
  }

  window.fetch = function (input, options) {
    var affectsCart = mutation(input, options);
    return fetchOriginal(input, options).then(function (response) {
      if (affectsCart && response.ok) schedule();
      return response;
    });
  };
  ['ema:cart-add-success', 'on:line-item:change', 'cart:updated', 'on:bfcache:load-restore'].forEach(function (event) {
    document.addEventListener(event, schedule);
  });
  window.addEventListener('pageshow', schedule);
  window.addEventListener('focus', schedule);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
  window.emaEnsureFreeGlue = ensure;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  if (end > now()) setTimeout(function () { ensure().catch(function () {}); }, Math.min(end - now() + 100, 2147483000));
}());
